const subscribeCustomerToNewsletter = async (payload: object) => {

	const controllerUrl = '/mobler-api/session/klaviyo/SubscribeFromCheckout'; // Adjust the URL to match your API route
	try {
		const response = await fetch(controllerUrl, {
			method: 'POST',
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(payload)
		});

		if (response.ok) {
			const responseData = await response.json();
			console.log('Response:', responseData);
		} else {
			console.error('Error:', response.statusText);
			const errorData = await response.json();
			console.error('Error Details:', errorData);
		}
	} catch (error) {
		console.error('Fetch Error:', error);
	}
}

export { subscribeCustomerToNewsletter }
